module.exports = __webpack_public_path__ + "static/QuotePDFPreview-02a481e6ae003a1c8ad26023dcd5e055.png";